import { logger } from './Logger'

const log = logger.createChildLogger({ name: 'LiveKitManifestSupport' })

export default class LiveKitManifestSupport {
    static map: Map<string, boolean> = new Map()

    static markSupported(sessionId: string) {
        if (!this.map.has(sessionId)) {
            log.checkpoint('mark_livekit_manifest_supported_peer', '', { sessionId })
        }
        this.map.set(sessionId, true)
    }

    static isSupported(sessionId: string): boolean {
        return this.map.get(sessionId) ?? false
    }
}
